import React, { useEffect, useState } from 'react';
import { SIDEBAR_GROUPS } from 'services/ai_management_card_modal';
import { Container } from './styles';

interface AiManagementCardModalSidebarProps {
  activeSection: string;
  counts: Record<string, number | undefined>;
  onSelect: (key: string) => void;
}

const AiManagementCardModalSidebar: React.FC<AiManagementCardModalSidebarProps> = ({
  activeSection,
  counts,
  onSelect,
}) => {
  const [expandedGroups, setExpandedGroups] = useState<string[]>(['ferramentas']);

  useEffect(() => {
    const group = SIDEBAR_GROUPS.find((candidate) =>
      candidate.items.some((item) => item.key === activeSection),
    );
    if (!group) return;
    setExpandedGroups((groups) => (groups.includes(group.key) ? groups : [...groups, group.key]));
  }, [activeSection]);

  const toggleGroup = (key: string) => {
    setExpandedGroups((groups) =>
      groups.includes(key) ? groups.filter((group) => group !== key) : [...groups, key],
    );
  };

  return (
    <Container className="border-right p-3 flex-shrink-0 overflow-auto">
      {SIDEBAR_GROUPS.map((group) => {
        const expanded = expandedGroups.includes(group.key);
        return (
          <div key={group.key} className="mb-2">
            <button
              type="button"
              className="sidebar-group-title d-flex align-items-center justify-content-between w-100 border-0 bg-transparent font-weight-bold px-2 py-2"
              onClick={() => toggleGroup(group.key)}
            >
              {group.label}
              <i className="material-icons">{expanded ? 'expand_less' : 'expand_more'}</i>
            </button>
            {expanded &&
              group.items.map((item) => {
                const active = activeSection === item.key;
                const count = counts[item.key];

                return (
                  <button
                    key={item.key}
                    type="button"
                    className={`sidebar-link d-flex align-items-center w-100 border-0 bg-transparent text-left rounded px-2 py-2 mt-1 ${
                      active ? 'active' : ''
                    }`}
                    onClick={() => onSelect(item.key)}
                  >
                    <i className="material-icons mr-2">{item.icon}</i>
                    <span className="flex-grow-1">{item.label}</span>
                    {count !== undefined && (
                      <span
                        className={`sidebar-count badge ml-2 ${
                          active ? 'badge-success' : 'badge-secondary'
                        }`}
                      >
                        {count}
                      </span>
                    )}
                  </button>
                );
              })}
          </div>
        );
      })}
    </Container>
  );
};

export default AiManagementCardModalSidebar;
